import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FnLocalStorageService } from '../services/fn-local-storage.service';
import { FnLangConstant } from '../constant/fn-language.constant';
import { isNull } from '../util/check';

export type SUPPORTED_LANGUAGES =
	| 'en'
	| 'de'
	| 'fr'
	| 'es'
	| 'it'
	| 'af'
	| 'da'
	| 'nl'
	| 'zh';

@Injectable()
export class FnI18nService extends FnLocalStorageService {
	private i18nDataMap: Map<string, string>;
	private selectedLang: SUPPORTED_LANGUAGES = 'en';
	public languageSelected = new Subject<SUPPORTED_LANGUAGES>();

	constructor(
		private http: HttpClient,
		private translateService: TranslateService
	) {
		super();
		//this.reset();
		this.languageSelected.subscribe((language: SUPPORTED_LANGUAGES) => {
			this.translateService.use(language);
			this.selectedLang = language;
		});
	}

	get lang(): SUPPORTED_LANGUAGES {
		const lang = this.selectedLang;
		// tslint:disable-next-line: deprecation
		if (isNull(lang)) {
			this.reset();
		}
		return this.selectedLang;
	}

	setLanguage(lang: SUPPORTED_LANGUAGES) {
		this.selectedLang = lang;
		this.translateService.use(lang);
		this.languageSelected.next(lang);
		this.setItem(FnLangConstant.LANG_KEY, lang);
	}

	reset() {
		this.selectedLang = 'en';
		this.setDefaultlang('en');
	}

	setDefaultlang(lang: SUPPORTED_LANGUAGES) {
		this.translateService.setDefaultLang(lang);
		this.setLanguage(lang);
	}

	translate(key: string): string {
		return this.translateService.instant(key);
	}
	get(key: string): Observable<string> {
		return this.translateService.get(key);
	}

	loadTranslations(
		lang: SUPPORTED_LANGUAGES,
		path: string = `./assets/i18n/${lang}.json`
	): void {
		this.http.get(path).subscribe((messageJson: object) => {
			this.loadTranslateMessage(lang, messageJson);
		});
	}

	loadTranslateMessage(lang: SUPPORTED_LANGUAGES, messageJson: object): void {
		this.translateService.setTranslation(lang, messageJson, true);
	}

	errorMessage(fieldKey: string, validatorType: string) {
		return fieldKey + '_' + validatorType;
	}
}
